import React, { FC } from 'react';
import styled from 'styled-components';

export type LendiWidgetName = 'BaseInstallmentPicker' | 'MeetingPlannerWidget';

const WIDGET_CONFIG: Record<LendiWidgetName, { query: string; scrollable: boolean }> = {
    BaseInstallmentPicker: {
        query: 'primaryColor=%230A68EB&dark=false&utm_fp_source_id=1313&utm_fp_partner_id=1701',
        scrollable: true
    },
    MeetingPlannerWidget: {
        query: 'primaryColor=%230A68EB&secondaryColor%5Balpha%5D=1&utm_fp_source_id=1313&utm_fp_partner_id=1701',
        scrollable: true
    }
};

const IframeContainer = styled.div<{ scrollable: boolean }>`
    width: 100%;
    display: flex;
    justify-content: center;
    flex: 1;

    iframe {
        width: 100%;
        max-width: 800px;
        height: 100%;
        min-height: 600px;
        border: none;
        overflow: ${(props) => props.scrollable ? 'auto' : 'hidden'};
    }
`;

interface LendiWidgetProps {
    widgetName: LendiWidgetName;
    price?: number;
}

const LendiWidget: FC<LendiWidgetProps> = ({ widgetName, price }) => {
    const config = WIDGET_CONFIG[widgetName];

    const priceParam = widgetName === 'BaseInstallmentPicker' && price
        ? `&amount=${price}&propertyValue=${price}&propertyPrice=${price}&value=${price}`
        : '';

    const overflowStyle = config.scrollable ? 'overflow-x: hidden;' : 'overflow: hidden;';

    const iframeContent = `
        <!DOCTYPE html>
        <html>
        <head>
            <meta charset="utf-8">
            <meta name="viewport" content="width=device-width, initial-scale=1">
            <style>
                * { box-sizing: border-box; }
                html, body {
                    margin: 0;
                    padding: 4px;
                    ${overflowStyle}
                    background: transparent;
                    display: flex;
                    justify-content: center;
                    align-items: flex-start;
                    min-height: 100%;
                }
                .lendi-widget {
                    width: 100%;
                    max-width: 100%;
                }
                .lendi-widget > div {
                    margin: 0 auto !important;
                }
            </style>
        </head>
        <body>
            <script async src="https://embed.lendi.pl/widget.js"></script>
            <div class="lendi-widget"
                data-query="&${config.query}${priceParam}"
                data-widget-name="${widgetName}">
            </div>
        </body>
        </html>
    `;

    return (
        <IframeContainer scrollable={config.scrollable}>
            <iframe
                srcDoc={iframeContent}
                title={`Lendi ${widgetName}`}
                sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
            />
        </IframeContainer>
    );
};

export default LendiWidget;
